import * as _ from "lodash-es";

export default {
  namespaced: true,
  state: {
    addressBookItemsMap: {},
  },
  mutations: {
    setItems: function (state, addressBookItems) {
      state.addressBookItemsMap = _.keyBy(addressBookItems, "id");
    },
    updateItem(state, item) {
      state.addressBookItemsMap = { ...state.addressBookItemsMap, [item.id]: item };
    },
    deleteItem(state, itemId) {
      delete state.addressBookItemsMap[itemId];
      state.addressBookItemsMap = { ...state.addressBookItemsMap };
    },
  },
  getters: {
    items(state) {
      return _.orderBy(Object.values(state.addressBookItemsMap), ["email"]);
    },
    addressBookByEmail(state) {
      return _.keyBy(state.addressBookItemsMap, "email");
    },
    emailOptions(state, getters) {
      return getters.items.map((i) => i.email);
    },
  },
};
